import { useSelector } from 'react-redux';
import { RootState } from 'store/configureStore';
import { State as CaseState } from 'modules/cm/store/cases/types';

const useReduxCase = () => {
  return useSelector((state: RootState) => {
    return state.currentCase as NonNullable<CaseState>;
  });
};

export default useReduxCase;
